import React, { useEffect } from "react";
import { useUserAssignedPages } from "../../context/UserAssignedPagesContext";
import AccessDenied from "./AccessDenied";
import BarChartLoader from "./BarChartLoader";
import NavHeader from "../nav/NavHeader";
import SideMenu from "../nav/Sidemenu";

/**
 * Route guard — only renders children if the current user's Tool Roles
 * grant access to `pageKey` (must match a key in the backend PAGE_CATALOG).
 */
const RequirePageAccess = ({ pageKey, children }) => {
  const { pageKeys, status, ensureLoaded } = useUserAssignedPages();

  useEffect(() => {
    ensureLoaded().catch(() => {});
  }, [ensureLoaded]);

  const accessStatus =
    status === "idle" || status === "loading"
      ? "loading"
      : status === "loaded" && pageKeys.includes(pageKey)
      ? "allowed"
      : "denied";

  if (accessStatus === "loading") {
    return (
      <div>
        <NavHeader />
        <SideMenu />
        <div style={{ marginLeft: "85px", marginTop: "80px", minHeight: "calc(100vh - 80px)", display: "grid", placeItems: "center", background: "#f9f9f9" }}>
          <div className="w-full max-w-md rounded-2xl border border-slate-200/80 bg-white p-10 text-center shadow-lg">
            <BarChartLoader label={null} />
            <h2 className="mt-6 text-lg font-bold text-slate-900">Checking your access…</h2>
            <p className="mx-auto mt-2 max-w-sm text-sm leading-6 text-slate-500">
              Please wait while we verify your permissions for this page.
            </p>
          </div>
        </div>
      </div>
    );
  }

  if (accessStatus === "denied") {
    return (
      <div>
        <NavHeader />
        <SideMenu />
        <div style={{ marginLeft: "85px", marginTop: "80px" }}>
          <AccessDenied minHeight="calc(100vh - 80px)" />
        </div>
      </div>
    );
  }

  return children;
};

export default RequirePageAccess;
